export function SectionHeader({ id, title, description }) {
  return (
    <div id={id} className="scroll-mt-20 pt-8 pb-4 border-b">
      <h2 className="text-2xl font-bold">{title}</h2>
      {description && (
        <p className="text-muted-foreground mt-1">{description}</p>
      )}
    </div>
  )
}
